/**
 * @file IconAdd Icon
 * @author Auto Generated by @polyv/icons-cli
 */

import { IconBuilder } from '@polyv/icons-vue/icon-builder';

export default IconBuilder(
  'icon-add',
  (data) => `
<svg width="${data.size}" height="${data.size}" viewBox="0 0 16 16">
  <g fill="none" fill-rule="evenodd" stroke="none" stroke-width="1">
    <path
      fill="${data.colorDesc[0]}"
      fill-rule="nonzero"
      d="M8,0 C12.418278,0 16,3.581722 16,8 C16,12.418278 12.418278,16 8,16 C3.581722,16 0,12.418278 0,8 C0,3.581722 3.581722,0 8,0 Z M8,1 C4.13400675,1 1,4.13400675 1,8 C1,11.8659932 4.13400675,15 8,15 C11.8659932,15 15,11.8659932 15,8 C15,4.13400675 11.8659932,1 8,1 Z M8,3.9 C8.24545989,3.9 8.44960837,4.07687516 8.49194433,4.31012437 L8.5,4.4 L8.5,7.499 L11.6,7.5 C11.8761424,7.5 12.1,7.72385763 12.1,8 C12.1,8.24545989 11.9231248,8.44960837 11.6898756,8.49194433 L11.6,8.5 L8.5,8.499 L8.5,11.6 C8.5,11.8761424 8.27614237,12.1 8,12.1 C7.75454011,12.1 7.55039163,11.9231248 7.50805567,11.6898756 L7.5,11.6 L7.5,8.499 L4.4,8.5 C4.12385763,8.5 3.9,8.27614237 3.9,8 C3.9,7.75454011 4.07687516,7.55039163 4.31012437,7.50805567 L4.4,7.5 L7.5,7.499 L7.5,4.4 C7.5,4.12385763 7.72385763,3.9 8,3.9 Z"
    />
  </g>
</svg>
`
);
